import {mxImage} from './mxGraphFactory';
import Base64 from './Base64';

const createSvgImage = (w, h, data) => {
    const tmp = unescape(encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="${w}px" height="${h}px" preserveAspectRatio="xMidYMid meet">${data}</svg>`));
    return new mxImage('data:image/svg+xml;base64,' + ((window.btoa) ? btoa(tmp) : Base64.encode(tmp, true)), w, h)
};

const definition = {
    splitType: 'Or',
    joinType: 'Or',
    type: 'Simple'
};

const createSimpleTask = name => ({
    name,
    ...definition
});

const createHttpTask = name => ({
    name,
    ...definition,
    type: 'Http'
});

const createAIChatTask = name => ({
    name,
    ...definition,
    type: 'AIChat',
    chatModel: {
        credentials: '',
        provider: '',
        model: ''
    }
});

const createJsonDocumentReaderTask = name => ({
    name,
    ...definition,
    type: 'JsonDocumentReader',
    sourceExpression: ''
});

const createJsonConverterTask = name => ({
    name,
    ...definition,
    type: 'JsonConverter',
    sourceType: null,
    sourceExpression: ''
});

const createTextDocumentReaderTask = name => ({
    name,
    ...definition,
    type: 'TextDocumentReader',
    sourceExpression: ''
});

const createHtmlDocumentReaderTask = name => ({
    name,
    ...definition,
    type: 'HtmlDocumentReader',
    sourceExpression: ''
});

const createMarkdownDocumentReaderTask = name => ({
    name,
    ...definition,
    type: 'MarkdownDocumentReader',
    sourceExpression: ''
});

const createAIVectorStoreTask = name => ({
    name,
    ...definition,
    type: 'AIVectorStore',
    vectorStore: ''
});

const createYamlDocumentReaderTask = name => ({
    name,
    ...definition,
    type: 'YamlDocumentReader',
    sourceExpression: ''
});

const createAIVectorSearchTask = name => ({
    name,
    ...definition,
    type: 'AIVectorSearch',
    vectorStore: ''
});

const createAIVectorDeleteTask = name => ({
    name,
    ...definition,
    type: 'AIVectorDelete',
    vectorStore: ''
});

const createJQTask = name => ({
    name,
    ...definition,
    type: 'JQ'
});

const createWaitTask = name => ({
    name,
    ...definition,
    type: 'Wait'
});

const createEmailTask = name => ({
  name,
  ...definition,
  type: 'Email'
});

const createMapTask = name => ({
  name,
  ...definition,
  type: 'Map'
});

const createTerminateTask = name => ({
    name,
    ...definition,
    terminationStatus: 'Completed',
    type: 'Terminate'
})

const createRoute = name => ({
    name,
    routingType: 'UnConditional',
    conditions: {}
})

const deepCopy = obj => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (obj instanceof Array) {
        return obj.reduce((arr, item, i) => {
            arr[i] = deepCopy(item);
            return arr;
        }, []);
    }

    if (obj instanceof Object) {
        return Object.keys(obj).reduce((newObj, key) => {
            newObj[key] = deepCopy(obj[key]);
            return newObj;
        }, {})
    }
};

export {
    createSvgImage,
    deepCopy,
    createSimpleTask,
    createHttpTask,
    createAIChatTask,
    createJsonDocumentReaderTask,
    createJsonConverterTask,
    createTextDocumentReaderTask,
    createHtmlDocumentReaderTask,
    createMarkdownDocumentReaderTask,
    createYamlDocumentReaderTask,
    createAIVectorStoreTask,
    createAIVectorSearchTask,
    createAIVectorDeleteTask,
    createJQTask,
    createWaitTask,
    createEmailTask,
    createTerminateTask,
    createMapTask,
    createRoute
};
